export enum TransactionType {
  Issue = 'Issue',
  Redeem = 'Redeem',
  Transfer = 'Transfer'
}
